import { isLocal } from "@/lib/environment";
import { isPostHogEnabled } from "./is-posthog-enabled";

/**
 * Whether analytics events leave the app for PostHog.
 *
 * Local reads feature flags from PostHog but sends nothing back: no capture, no pageview, no
 * identify, no session replay. Each PostHog client installs a `before_send` hook that drops every
 * event when this is false, and our own capture helpers return early. Flag requests are not
 * events, so they still go out. Deployed preview/sandbox/prod send as usual.
 * There is no env override. To send events from local, change this guard and do not commit it.
 */
export function shouldSendPostHogEvents(): boolean {
  return isPostHogEnabled() && !isLocal();
}
